/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ImagesOfBlog = styled.img`
  width: min-content;
  max-width: 100%;
`;
